import React from 'react';
import { createStructuredSelector } from 'reselect';
import { ApplicationRootState } from '../../types';
import { useDispatch, useSelector } from 'react-redux';
import Panel from '../../components/Panel';
import { displayUpperShelfPanelAction } from './actions';
import { selectIsVisibleUpperShelfPanel } from './selectors';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from '../UpperShelfPanel/reducer';
import UpperShelfPanelContent from './UpperShelfPanelContent';
import { useTranslation } from 'react-i18next';

interface StateProps {
  isVisible: boolean;
}

const stateSelector = createStructuredSelector<
  ApplicationRootState,
  StateProps
>({
  isVisible: selectIsVisibleUpperShelfPanel(),
});

const UpperShelfPanel = () => {
  useInjectReducer({ key: 'upperShelfPanel', reducer: reducer });
  const dispatch = useDispatch();
  const { isVisible } = useSelector(stateSelector);

  const { t } = useTranslation();

  const hidePanel = () => {
    dispatch(displayUpperShelfPanelAction(false));
  };

  return (
    <Panel close={hidePanel} isVisible={isVisible} autoclose={false}>
      <div className="flex justify-center items-center h-full">
        <div>
          <div className="mr-12 text-xl italic">
            {t('Choose your top shelf')}
          </div>
          <div className="text-gray-700 text-sm w-96">
            {t('A top shelf is not mandatory')}
          </div>
        </div>
        <UpperShelfPanelContent />
      </div>
    </Panel>
  );
};

export default UpperShelfPanel;
